const FINANCE_UNLOCK_TOKEN_KEY = 'financeUnlockToken';

let memoryToken = sessionStorage.getItem(FINANCE_UNLOCK_TOKEN_KEY) || '';

function notifyFinanceTokenChanged() {
  window.dispatchEvent(new Event('finance-unlock-token-changed'));
}

export function getFinanceUnlockToken() {
  return memoryToken || sessionStorage.getItem(FINANCE_UNLOCK_TOKEN_KEY) || '';
}

export function setFinanceUnlockToken(token) {
  memoryToken = token || '';

  if (memoryToken) {
    sessionStorage.setItem(FINANCE_UNLOCK_TOKEN_KEY, memoryToken);
  } else {
    sessionStorage.removeItem(FINANCE_UNLOCK_TOKEN_KEY);
  }

  notifyFinanceTokenChanged();
}

export function clearFinanceUnlockToken() {
  memoryToken = '';
  sessionStorage.removeItem(FINANCE_UNLOCK_TOKEN_KEY);
  notifyFinanceTokenChanged();
}
